import {Component, HostBinding, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from './services/language/language.service';
import {ViewService} from './services/view/view.service';
import {UtilService} from './services/util/util.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  template: '<router-outlet *ngIf="!isIE"></router-outlet><app-login *ngIf="isIE"></app-login>'
})
export class AppComponent implements OnInit {
  @HostBinding('class.test') get isTest() { return this.theme === 'test'; }
  public theme: string;
  private themeWrapper = document.querySelector('body');
  public isIE = UtilService.getBrowser('ie');

  constructor(
    private translateService: TranslateService,
    private languageService: LanguageService,
    public viewService: ViewService,
    private sanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    private utilService: UtilService) {
    iconRegistry.addSvgIconSet(sanitizer.bypassSecurityTrustResourceUrl('assets/img/svg/custom-icon-set.svg'));
    translateService.setDefaultLang(this.languageService.selectedLang);
    languageService.checkLang();
    if (this.viewService.conf.theme) {
      this.theme = this.viewService.conf.theme;
    }
  }

  public ngOnInit(): void {
    this.languageService.updateLanguages();
    const nav = navigator as any;
    if ('virtualKeyboard' in nav) {
      this.utilService.virtualKeyboardSupported = true;
      nav.virtualKeyboard.overlaysContent = true
      nav.virtualKeyboard.addEventListener('geometrychange', (event: any) => {
        const { height } = event.target.boundingRect;
        this.utilService.virtualKeyboardOpenedChange.emit(height);
      });
    }
  }
}
